/**
 * Logo de Fundamentales por idioma. El arte llega rotulado, así que hay un archivo
 * por idioma en vez de un texto traducido.
 *
 * Solo existen cinco versiones. Los idiomas sin arte propio —alemán y neerlandés—
 * caen al inglés, que es el respaldo acordado.
 */

import { asset } from '@/utils/basePath';
const LOGO_BY_LANGUAGE: Record<string, string> = {
  es: asset('/assets/logo-fundamentales-es.svg'),
  en: asset('/assets/logo-fundamentales-en.svg'),
  fr: asset('/assets/logo-fundamentales-fr.svg'),
  pt: asset('/assets/logo-fundamentales-pt.svg'),
  ro: asset('/assets/logo-fundamentales-ro.svg'),
};

const FALLBACK_LOGO = LOGO_BY_LANGUAGE['en'];

/**
 * Ruta del logo para el idioma dado. Acepta tanto códigos cortos (`es`) como
 * completos (`es-MX`), y responde con el logo en inglés para cualquier idioma
 * sin arte propio.
 */
export function fundamentalsLogoSrc(lang: string): string {
  const shortCode = lang.split('-')[0].toLowerCase();
  return LOGO_BY_LANGUAGE[shortCode] ?? FALLBACK_LOGO;
}
